import { Construction } from 'src/interfaces/construction.interface'
import { coreAPI } from './base.service'

export function getAllConstructions(): Promise<Construction[]> {
  const path = `/v1/constructions`
  const req = coreAPI.get(path)
  return req.then((res) => res?.data)
}
